






























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { UsersService } from "@/services/api/users.service";
import { Getter } from "vuex-class";
import { LanguageDto, UserDto } from "@/server/app.dtos";
import {
  GetUserDtoQuery,
  GetUsersDtosIncludeOptions
} from "@/server/app.queries";
import { ISideMenuItem } from "@/models/menus/isidemenu";
import ConfigsService from "@/services/api/configs.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { concatUrls } from "@/utilities/url";

@Component
export default class UserDetailSharedPage extends Vue {
  usersService: UsersService = new UsersService();
  configsService: ConfigsService = new ConfigsService();
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  user: UserDto | null = null;
  menus: ISideMenuItem[] = [
    {
      icon: "las la-cog",
      title: "Dashboard",
      url: "dashboard"
    },
    {
      icon: "las la-cog",
      title: "Logins",
      url: "logins"
    },
    {
      icon: "las la-cog",
      title: "Documentos",
      url: "documents"
    },
    {
      icon: "las la-list",
      title: "Detalhes",
      url: "details"
    },
    {
      icon: "las la-comments",
      title: "Comentários",
      url: "comments"
    },
    {
      icon: "las la-comments",
      title: "Logs",
      url: "logs"
    }
  ];;
  actionMenu: boolean = false;
  isLoading: boolean = false;

  get currentPath(): string {
    return this.$route.path;
  }

  get getPhotoSrc(): string {
    return this.user && this.user.photo
      ? concatUrls(process.env.VUE_APP_CDN_URL, this.user.photo)
      : "/img/user.jpg";
  }

  @Watch("$route")
  onRouteChange() {
    this.Load();
  }

  async created() {
    // this.menus = this.getMenu("Users", "UsersDetails");
    await this.Load();
  }

  async Load() {
    const query = new GetUserDtoQuery();
    query.idLanguage = this.currentLanguage.idLanguage;
    query.idUser = parseInt(this.$route.params.id);
    query.includes = new GetUsersDtosIncludeOptions();
    query.includes.appGroups = true;
    query.includes.entity = true;
    query.includes.metadata = true;
    query.includes.userType = true;
    await this.usersService
      .GetSingle(query)
      .then((result: UserDto) => {
        this.user = result;
      })
      .catch(() => (this.user = null));
  }

  async deleteUser() {
    if (this.isLoading) {
      return;
    }
    if (this.user) {
      await this.usersService
        .DeleteById(this.user.idUser || 0)
        .catch((error: any) => NotificationServiceBus.showError(error))
        .then(() => this.$router.push("/users/"));
    }
  }
}
